import { handleAuthorization, handleOkResponseJson, handleBadRequest400, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';
import { normalizeTextUppercase, normalizeItemsUppercase } from '../utils'

function normalizeMapaCotacaoPayload(payload) {
	if (!payload) {
		return payload;
	}

	const normalized = { ...payload };
	if (Object.prototype.hasOwnProperty.call(normalized, 'informacoesAdicionais')) {
		normalized.informacoesAdicionais = normalizeTextUppercase(normalized.informacoesAdicionais);
	}
	if (Object.prototype.hasOwnProperty.call(normalized, 'fornecedores')) {
		normalized.fornecedores = normalizeItemsUppercase(normalized.fornecedores, ['observacao']);
	}
	if (Object.prototype.hasOwnProperty.call(normalized, 'itens')) {
		normalized.itens = normalizeItemsUppercase(normalized.itens, ['observacao', 'enderecoColeta']);
	}

	return normalized;
}

export default {
	obterMetricasAsync,
}

export const obterMapasCotacaoAsync = async () => {
	const requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
	};
	return fetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/obterLista`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarMapaCotacaoAsync = async (payload) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify(normalizeMapaCotacaoPayload(payload))
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao`, requestOptions);
}

export const atualizarMapaCotacaoAsync = async (payload) => {
	const requestOptions = {
		method: 'PUT',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify(normalizeMapaCotacaoPayload(payload))
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao`, requestOptions);
}

export const gerarPedidoMapaCotacaoAsync = async (payload) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify(normalizeMapaCotacaoPayload(payload))
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/gerarPedido`, requestOptions);
}

export const inativarMapaCotacaoAsync = async (id, consideracoes) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, consideracoes })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/inativar`, requestOptions);
}

export const aprovarMapaCotacaoAsync = async (id, consideracoes) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, consideracoes })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/aprovar`, requestOptions);
}

export const desautorizarMapaCotacaoAsync = async (id, consideracoes) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, consideracoes })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/desautorizar`, requestOptions);
}

export const declinarMapaCotacaoAsync = async (id, consideracoes) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, consideracoes })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/declinar`, requestOptions);
}

export const deaprovarMapaCotacaoAsync = async (id, consideracoes) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, consideracoes })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/desautorizar`, requestOptions);
}

export const enviarEmailComAnexoAsync = async (formData) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Authorization': 'bearer ' + obterToken() }, // sem 'Content-Type' — o browser define!
		body: formData
	};

	return fetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/enviarEmail`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
};

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/MapaCotacao/downloadRequisicoes`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'mapas_de_compra' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}

export function getPdf(id, janelaPdf = null) {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/MapaCotacao/downloadPdf/` + id,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			fecharJanelaPdf(janelaPdf);
			return { status: false };
		})
			.then((response) => {
				if (response.status === false) {
					fecharJanelaPdf(janelaPdf);
					return response;
				}
				abrirBlobPdf(response.data, janelaPdf);
			});
	} catch (e) {
		fecharJanelaPdf(janelaPdf);
		throw e;
	}
}


export const obterMetricasAsync = async () => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
  };

  return fetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/metricas`, requestOptions)
    .then(handleAuthorization)
    .then(handleOkResponseJson)
    .then(result => result.data);
}

export const inativarItemMapaCotacaoAsync = async (idMapa, idSolicitacaoItem, justificativa) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ idMapa, idSolicitacaoItem, justificativa })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/MapaCotacao/inativarItem`, requestOptions);
}
